import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useGame } from "@/context/GameContext";

export default function AuthCallback() {
  const nav = useNavigate();
  const { refresh } = useGame();
  const done = useRef(false);
  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(window.location.hash.slice(1)).get("session_id");
    (async () => {
      try {
        await api.post("/auth/google-session", { session_id: sid });
        window.history.replaceState(null, "", "/journey");
        await refresh();
        nav("/journey", { replace: true });
      } catch {
        toast.error("Google sign-in failed. Please try again.");
        window.history.replaceState(null, "", "/login");
        nav("/login", { replace: true });
      }
    })();
  }, [nav, refresh]);
  return <div data-testid="auth-callback" className="min-h-screen" />;
}
